import { render, staticRenderFns } from "./table34.vue?vue&type=template&id=982ab118&scoped=true&"
import script from "./table34.vue?vue&type=script&lang=js&"
export * from "./table34.vue?vue&type=script&lang=js&"
import style0 from "./table34.vue?vue&type=style&index=0&id=982ab118&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "982ab118",
  null
  
)

export default component.exports